import { GetterTree } from 'vuex';
import { SmartState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<SmartState, RootState> = {};
